const ViewsFactory = require('public_framework/views_factory')

const eventsListPath = 'events_list'

const Components = {
  Community: {
    Event: require('./views/event'),
    EventsList: require(`./views/${eventsListPath}`)
  },
  Ui: {
    Map: require('public_shared_components/ui/map/views/map'),
    Slider: require('public_shared_components/ui/slider/views/slider'),
    Toggle: require('public_shared_components/ui/toggle/views/toggle'),
    Datepicker: require('public_shared_components/ui/datepicker/views/datepicker'),
    LocationAutocomplete: require('public_shared_components/ui/autocomplete/views/location_autocomplete'),
    RemoteAutocomplete: require('public_shared_components/ui/autocomplete/views/remote_autocomplete')
  }
}

ViewsFactory.addComponents(Components)



// WEBPACK FOOTER //
// ./front/apps/public/pages/community/javascripts/index.js